import Cookies from 'js-cookie';

export const logout = () => {
	Cookies.remove('session');
	localStorage.clear();

	// Reload URL to let app decide what should happen next when cookie doesn't exist
	window.location.reload();
};

export default logout;


// WEBPACK FOOTER //
// ./src/utils/auth/logout.js